import { Button } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { getLodingStatus, parsePermission, setCookeis } from "../../commonModule";
import { LoadingSpinner, PermissionDenied } from "../common/commonParts";

export const ChangeConnect = () => {
  const apiChHandler = (e) =>{
    const name = e.currentTarget.name;
    setCookeis('endPoint', name);
  }
  const allState = useSelector(state=>state);
  const ss = getLodingStatus(allState);
  const {account} = allState;
  if (!ss.loaded && !ss.error){
    return <LoadingSpinner/>
  }
  else if (ss.error){
    return <div style={{margin:"120px 0 0 120px"}}>error occured.</div>
  }
  const permission = parsePermission(account)[0][0];
  if (permission < 100){
    return <PermissionDenied marginTop='120' />
  }
  return (
    <div style={{margin:"120px 0 0 120px"}}>
      <div style={{padding: 8}}>change endpoint</div>
      <div style={{margin: 8}}>
        <Button
          name = 'apixfg'
          color='primary' variant='outlined' 
          onClick={(e)=>apiChHandler(e)}
        >
          apixfg
        </Button>

      </div>
      <div style={{margin: 8}}>
        <Button
          name = 'apidev'
          color='primary' variant='outlined' 
          onClick={(e)=>apiChHandler(e)}
        >
          apidev
        </Button>
        
      </div>
      <div style={{margin: 8}}>
        <Button
          name = 'api'
          color='primary' variant='outlined' 
          onClick={(e)=>apiChHandler(e)}
        >
          api
        </Button>
        
      </div>

    </div>
  )
}
export default ChangeConnect;